<ng-content/>
@if (loading()) {
  <app-loading-icon [grey]="grey()" [small]="small()"/>
}
@if (text() && success()) {
  <p class="loading-text">{{ text() }}</p>
}
